export default __webpack_public_path__ + "static/media/2045.b8687b56.png";